import { Component, OnInit } from "@angular/core";
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { AuthService } from "src/app/core/services/AuthService";
import { BrandingService } from "src/app/core/services/branding.service";
import { CertificadoService } from "src/app/core/services/certificado.service";
import { InstitutionSettings } from "src/app/core/services/institution-settings.service";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { PushNotificationsService } from "src/app/core/services/push-notifications.service";
import { k } from "src/environments/properties";
import Swal from "sweetalert2";
import { AuthSessionService } from "src/app/core/services/AuthSessionService";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public loginForm: UntypedFormGroup;
  public registerForm: UntypedFormGroup;
  public active = 1;
  showPassword: boolean = false;

  formLoginIsSubmited: boolean;
  returnUrl = "/dashboard/default";
  returnUrlProfile = "/perfil/perfil";

  settings: InstitutionSettings | null = null;
  logoUrl: string | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    public brandingService: BrandingService,    
    private authSessionService: AuthSessionService,
  ) {
    this.createLoginForm();
    this.createRegisterForm();
  }

  owlcarousel = [
    {
      title: "Bienvenidos a Firma 365",
      desc: "",
    },
  ];
  owlcarouselOptions = {
    loop: true,
    items: 1,
    dots: true,
  };

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: new FormControl("", [Validators.required]),
      password: new FormControl("", [Validators.required]),
    });

    this.minusculas(this.loginForm, "userName");
  }
  createRegisterForm() {
    this.registerForm = this.formBuilder.group({
      userName: [""],
      password: [""],
      confirmPassword: [""],
    });
    this.minusculas(this.registerForm, "userName");
  }

  minusculas(form: UntypedFormGroup, input: string) {
    form.get(input)?.valueChanges.subscribe((value) => {
      if (value) {
        form.get(input)?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  ngOnInit() {
    this.logoUrl =
      this.brandingService.getLogoUrl() ||
      "assets/images/dashboard/logo-oscuro.png";
    this.brandingService.settings$.subscribe(() => {
      this.logoUrl = this.brandingService.getLogoUrl();
    });
  }

  async onSubmit(): Promise<void> {

  this.formLoginIsSubmited = true;

  if (!this.loginForm.valid) {

    Swal.fire({
      title: '¡Campos requeridos!',
      text: 'Completa los campos de usuario y contraseña por favor',
      icon: 'warning',
      confirmButtonText: 'Ok',
    });

    return;
  }

  try {

    const loginResult: any =
      await this.authService.login(
        this.loginForm.value.userName,
        this.loginForm.value.password
      );


    /*
     * ==========================================
     * LOGIN REQUIERE MFA
     * ==========================================
     */

    if (
      loginResult?.requires_2fa &&
      loginResult?.partial_token
    ) {

      /*
       * Siempre guardamos el token parcial antes
       * de entrar a cualquier flujo MFA.
       */
      localStorage.setItem(
        k.partial_token,
        loginResult.partial_token
      );


      /*
       * Debe configurar/resetear MFA
       */
      if (loginResult?.must_change_2fa) {

        await this.router.navigate([
          '/force-reset-mfa'
        ]);

        return;
      }


      /*
       * MFA ya configurado.
       * Solo debe ingresar su código.
       */
      await this.router.navigate([
        '/mfa'
      ]);

      return;
    }


    /*
     * ==========================================
     * LOGIN COMPLETO - NO REQUIERE MFA
     * ==========================================
     */

    if (
      !loginResult?.requires_2fa &&
      loginResult?.access_token?.trim()
    ) {

      await this.authSessionService.completeLogin(
        loginResult.access_token
      );

      return;
    }


    /*
     * Respuesta inesperada del backend
     */
    throw new Error(
      'Respuesta de autenticación no válida'
    );

  } catch (error) {

    console.error(
      'Error de autenticación:',
      error
    );

    Swal.fire(
      '¡Credenciales inválidas!',
      'El usuario o contraseña ingresados no son correctos',
      'error'
    );

    this.formLoginIsSubmited = false;
  }
}

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  navigateRestorePassword() {
    this.router.navigate(["recover-password"]);
  }

  onLogoError(event: any) {
    if (!event.target.src.includes("logo-oscuro.png")) {
      event.target.src = "assets/images/dashboard/logo-oscuro.png";
    }
  }
}
